<template>
  <div>
    我是独立页面{{name}}
  </div>
</template>

<script>
  export default{
    data(){
      return {
        name:'1'
      }
    }
  }
</script>

<style></style>
</style>



// WEBPACK FOOTER //
// src/views/statistics/index.vue